// <!-- START: Nedfinity -->
$(function(){
    // This file also loads globally; its price/table logic is PDP-only.
    if (!document.getElementById('ProductPrice')) return;
    const rows = $('#DiscountTable tbody tr');

    addQuantityButtonsClickListeners();
    addRowsClickListeners();
    onInputClickAway();
    onVariantChange();
    showNewPrice();
    addBoxPricesToTable();

    function addQuantityButtonsClickListeners(){
        $('.button-quantity').on('click', function(){
            const minimumOrderIncrement = $('#product-quantity-input').data("minimumOrderIncrement");
            var quantity = parseInt($('#product-quantity-input').val());
            
            if($(this).hasClass('button-increase')) {
                quantity+= minimumOrderIncrement;
            } else {
              if(quantity > minimumOrderIncrement) {
                quantity-= minimumOrderIncrement;
              }
            }
            quantity = (isNaN(quantity)) ? 1 : quantity;
            $('#product-quantity-input').val(quantity);
            showNewPrice();
        }); 
    }

    function onInputClickAway(){
        $('#product-quantity-input').on('blur', function(){
            showNewPrice();
            roundUpInputValue();
        }); 
    }

    function addRowsClickListeners(){
        rows.not('.disabled').each(function() { 
            $(this).on('click', function(event) {
                let quantity = $(event.currentTarget).data('units');
                $('#product-quantity-input').val(quantity);
                showNewPrice();
                roundUpInputValue();
            })
        })
    }

    function removeRowsClickListeners(){
        rows.filter('.disabled').each(function() { 
            $(this).off();
        })
    }

    function roundUpInputValue(){
        const minimumOrderIncrement = $('#product-quantity-input').data("minimumOrderIncrement");
        var quantity = parseInt($('#product-quantity-input').val());
    
        if (quantity % minimumOrderIncrement == 0) {
            quantity = Math.floor(quantity / minimumOrderIncrement) * minimumOrderIncrement;
        } else {
            quantity = (Math.floor(quantity / minimumOrderIncrement) * minimumOrderIncrement) + minimumOrderIncrement;
        }
    
        if (quantity <= 0) {
            quantity = minimumOrderIncrement;
        }
    
        quantity = (isNaN(quantity)) ? 1 : quantity;
        $('#product-quantity-input').val(quantity);
    }

    function onVariantChange(){
        const targetNode = document.getElementById('OptionValues');
        if (!targetNode) return;
        const config = { attributes: true, childList: false, subtree: false };
    
        const callback = function(mutationList, observer) {
            for(const mutation of mutationList) {
                if (mutation.type === 'attributes' && mutation.attributeName === "data-variant-option-chosen-value") {
                    const selectedVariantTitle = targetNode.getAttribute(mutation.attributeName);
                    
                    if(selectedVariantTitle !== "false"){
                        updatePriceDataWithVariant(selectedVariantTitle);
                        updateTable(selectedVariantTitle);
                        addBoxPricesToTable();
                        showNewPrice();
                    }
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    function updatePriceDataWithVariant(selectedVariantTitle){
        const variantPrice = getSelectedVariantPrice(selectedVariantTitle);
        $("#ProductPrice").attr("data-price", variantPrice)
    }

    function getSelectedVariantStock(selectedVariantTitle){
        return $('#VariantValues [data-title="' + selectedVariantTitle + '"]').data("stock");
    }

    function getSelectedVariantPrice(selectedVariantTitle){
        return $('#VariantValues [data-title="' + selectedVariantTitle + '"]').data("price");
    }

    function updateTable(variantTitle){
        const stock = getSelectedVariantStock(variantTitle);

        rows.each(function() {
            const units = $(this).data("units");
            if (stock < units){
                $(this).addClass('disabled');
                removeRowsClickListeners();
            } else if (stock >= units) {
                $(this).removeClass('disabled');
                addRowsClickListeners();
            }
        })
    }

    function showNewPrice(){
        const currentQuantity = $('#product-quantity-input').val();

        $(rows.get().reverse()).each(function() {
            const units = $(this).data("units");
            const discount = $(this).data("discount");

            if (currentQuantity >= units){
                renderPrice(discount);
                return false;
            } else {
                renderPrice(0);
            }
        })
    }

    function renderPrice(discount){
        const priceContainer = $("#ProductPrice");
        const priceSpan = $("#ProductPrice .price__current span");
        const minimumOrderIncrement = $('#product-quantity-input').data("minimumOrderIncrement");
        const price = getCurrentVariantPrice();

        const priceAfterDiscount = Math.round((price * (1 - discount)) * 100) / 100;
        priceSpan.html(priceAfterDiscount.toFixed(2).toString().replace('.', ','));
        
    }

    function addBoxPricesToTable(){
        const price = getCurrentVariantPrice();
        const minimumOrderIncrement = $('#product-quantity-input').data("minimumOrderIncrement");

        rows.each(function() {
            const discount = $(this).data("discount");
            const boxCell = $(this).find('.table-box-price');
            const palletCell = $(this).find('.table-pallet-saved');
            const priceAfterDiscount = Math.round((price * (1 - discount)) * 100) / 100;
            const palletSavedAmount = (price * minimumOrderIncrement) - (priceAfterDiscount * minimumOrderIncrement);

            boxCell.html(priceAfterDiscount.toFixed(2).toString().replace('.', ','));
            palletCell.html(palletSavedAmount.toFixed(2).toString().replace('.', ','));
        })
    }

    function getCurrentVariantPrice(){
        return parseFloat(document.getElementById('ProductPrice').dataset.price); 
    }

});
// <!-- EIND: Nedfinity -->
